/**
 * プロジェクト ID（UUID）は 8-4-4-4-12 の 36 文字固定。BE の
 * `Product.product_id`（UUIDField）と、slug バリデーション（UUID 形式の
 * slug は保存不可）の両方でこの形式が保証されている。
 */
export const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** 文字列が UUID（= プロジェクト ID）形式かどうか */
export const isUuid = (value: string): boolean => UUID_PATTERN.test(value);
